import { createContext, useContext, useState } from "react";

const BookDemoContext = createContext(null);

export function BookDemoProvider({ children }) {
  const [open, setOpen] = useState(false);
  return (
    <BookDemoContext.Provider value={{ open, openDemo: () => setOpen(true), closeDemo: () => setOpen(false), setOpen }}>
      {children}
    </BookDemoContext.Provider>
  );
}

export function useBookDemo() {
  const ctx = useContext(BookDemoContext);
  if (!ctx) throw new Error("useBookDemo must be used within a BookDemoProvider");
  return ctx;
}
